import type { BusinessModel } from '../../data-layer/business/types';
import type { BusinessUI } from '../../ui/business/types';

export const toBusinessUI = (businessModel: BusinessModel): BusinessUI => businessModel;
